module.exports = __webpack_public_path__ + "static/media/Hånd.546adea8.PNG";